import { combineReducers } from "redux";
import { storeReducer } from './store';
import { globalReducer } from "./global";
import { bookingProcessReducer } from "./bookingProcess";
import { bookingConfirmationReducer } from "./bookingConfirmation";
import { storesReducer } from "./stores";
import { changeStoreModalReducer } from "./changeStoreModal";
import { settingsReducer } from "./settings";
import { editBookingState } from "./editBooking";
import { deleteBookingState } from "./deleteBooking";
import { preselectedStoreState } from "./preselectedStore";

export default combineReducers({
    globalReducer, storeReducer, bookingProcessReducer,
    bookingConfirmationReducer, storesReducer, changeStoreModalReducer,
    settingsReducer, editBookingState, deleteBookingState, preselectedStoreState,
});


// WEBPACK FOOTER //
// ./src/store/reducers/reducer.js